export default "__VITE_ASSET__CeAKKZgp__"